<template>
  <modal
    name="upload-confirmation-modal"
    height="auto"
    :width="isMobile ? '300px' : '550px'"
    :adaptive="true"
    :click-to-close="false"
    @before-open="resetData">
    <div class="upload-confirmation-modal-content">
      <div class="upload-confirmation-modal-header">
        WARNING! This is a {{environmentName}} environment!
      </div>
      <div class="upload-confirmation-modal-text">
        Are you sure you want to upload all settings to {{environmentName}} environment?
      </div>
      <div class="upload-confirmation-modal-text">
        Please type 'confirm' to enable the button:
      </div>
      <input
        class="upload-confirmation-modal-input"
        type="text"
        placeholder="Type 'confirm' to enable Confirm button..."
        v-model="inputValue"
        @keyup="validateInputAndEnableConfirm"
      />
      <div class="upload-confirmation-modal-buttons">
        <button type="button" @click="cancel" class="btn btn-dark">Cancel</button>
        <button @click="confirm" :disabled="!enableConfirmButton" class="btn btn-primary">Confirm</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      inputValue: null,
      enableConfirmButton: false
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768
    },
    environmentName() {
      return window.runtimeConfig.environmentName
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
      this.close()
    },
    confirm() {
      this.$emit('confirm')
      this.close()
    },
    close() {
      this.resetData()
      this.$modal.hide('upload-confirmation-modal')
    },
    validateInputAndEnableConfirm() {
      this.enableConfirmButton = this.inputValue === 'confirm'
    },
    resetData() {
      this.inputValue = null
      this.enableConfirmButton = false
    }
  }
}
</script>

<style scoped>
.upload-confirmation-modal-content {
  padding: 15px;
}

.upload-confirmation-modal-header {
  text-align: center;
  font-size: 18px;
}

.upload-confirmation-modal-text {
  margin: 10px 0;
}

.upload-confirmation-modal-buttons {
  display: flex;
  justify-content: space-evenly;
  margin: 10px 0;
}

.upload-confirmation-modal-input {
  width: 100%;
  margin: 10px 0;
}

.btn.btn-primary[disabled] {
  background-color: #888;
  border-color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadConfirmationModal.vue